import { useState } from "react";
import { Button, Menu, FormControlLabel, Radio, Grid, Divider, FormGroup, Checkbox } from "@mui/material";
import { withRouter } from "react-router-dom";
import { connect, useDispatch } from "react-redux";
import close from "../../../asset/image/close.svg";

const AdminSLFilters = (props) => {

    const { filterPopup, setFilterPopup, anchorElRef, setFilterPayload, filters, setFilters, setTableParams, tableParams } = props

   const allOptions: Record<string, Record<string, string>> = {
        status: {
            all: "All",
            active: "Active",
            inactive: "Inactive"
        },
        subscriptionstatus: {
            all: "All",
            active: "Subscribed",
            inactive: "UnSubscribed"
        },
        kit: {
            all: "All",
            hasKit: "Service Line with KIT",
            noKit: "Service Line without KIT"
        }
    };

    const defaultFilters = {
        status: "all",
        subscriptionstatus: "all",
        kit: "hasKit",
        // plan: "all"
    };


    const handleFilterChange = (key, value) => {
        setFilters((prev) => ({ ...prev, [key]: value }));
    };

    const handleApplyFilters = () => {
        const payload: any = {};

        if (filters.kit === "hasKit") {
            payload.kitFilter = "where kitCount > 0";
        } else if (filters.kit === "noKit") {
            payload.kitFilter = "where kitCount = 0";
        } else {
            payload.kitFilter = "where kitCount = 0 or kitCount > 0";
        }

        if (filters.subscriptionstatus === "active") {
            payload.subFilter = "where subs.active = 1";
        } else if (filters.subscriptionstatus === "inactive") {
            payload.subFilter = "where subs.active = 0";
        } else {
            payload.subFilter = "";
        }

        if (filters.status === "active") {
            payload.activeFilter = "and sel.active = true";
        } else if (filters.status === "inactive") {
            payload.activeFilter = "and sel.active = false";
        } else {
            payload.activeFilter = "";
        }
            setTableParams({
            ...tableParams,
            page: 1
        })
        setFilterPayload(payload)
    };

    const clearFilters = () => {
        setFilters({ ...defaultFilters });
    };

    return (
        <Menu
            open={filterPopup}
            className="rc--filter_menu_container_dashboard menuScroll strMaps-filter"
            anchorEl={anchorElRef}
        >
            <Grid className="sitesFilterHeaderMargin">
                <div className="filter-header">Filters</div>
                <img
                    src={close}
                    onClick={() => setFilterPopup(false)}
                    alt="Close"
                    className="activityReportsFilter-close"
                />
            </Grid>
            <Divider className="filter-border-color filter-divider-width" />
            <Grid className="usageFilterComponent">
                <div className="Form">
                    <Grid className="am-table dash-filter-pop">
                        {["Status", "Subscription Status", "KIT"].map((section) => {
                            const key = section.replace(/\s/g, "").toLowerCase();
                            // const options: any = allOptions[key];
                            const options: Record<string, string> = allOptions[key];

                            return (
                                <Grid className="sitesFiltersPadding" key={key}>
                                    <span className="internet-status-header">{section}</span>
                                    <FormGroup sx={{ padding: 0 }} className="filterComponents">
                                        {Object.entries(options).map(([optionKey, optionLabel]) => (
                                            <FormControlLabel
                                                key={optionKey}
                                                control={
                                                    <Radio
                                                        style={{ padding: "0px 8px" }}
                                                        checked={filters[key] === optionKey}
                                                        onChange={() => handleFilterChange(key, optionKey)}
                                                    />
                                                }
                                                label={optionLabel}
                                                className="sitesInternetStatusOptions starlinkMap-filterPopup"
                                            />
                                        ))}
                                    </FormGroup>
                                </Grid>
                            );
                        })}
                    </Grid>
                </div>
            </Grid>
            <Divider className="filter-border-color apply-filter-divider-width" />
            <div className="clearFiletrBtnDiv margin-left-filter">
                <Button className="clearFiletrBtnUsage padding-right-0" onClick={() => { clearFilters() }}>
                    Clear Filter
                </Button>
                <Grid className="dash-filter-pop">
                    <Button className="usage-applyFilterBtn" onClick={handleApplyFilters}>
                        Apply Filter
                    </Button>
                </Grid>
            </div>
        </Menu>
    );
}

const mapStateToProps = (state) => ({
  
});

export default withRouter(
    connect(mapStateToProps, {

    })(AdminSLFilters)
);